/* unplugin-vue-components disabled */import { render } from "./VipAgreement.vue?vue&type=template&id=b66e6030&scoped=true"
import script from "./VipAgreement.vue?vue&type=script&lang=js"
export * from "./VipAgreement.vue?vue&type=script&lang=js"

import "./VipAgreement.vue?vue&type=style&index=0&id=b66e6030&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/zeta-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b66e6030"]])

export default __exports__